import React from "react"
import { Link } from "react-router-dom"
import { SmartDateFormat } from "../../util/dates"

interface AttachedMediaItem {
  url?: string
}

interface LinkPreview {
  best_image?: string
}

interface Headline {
  id: number
  title: string
  title_cleaned?: string
  post_type_nice?: string
  cover_image_url_large?: string
  attached_media?: AttachedMediaItem[]
  external_photo_src?: string
  link_preview?: LinkPreview
  published_at: string
  band_name?: string
  nada_path: string
}

interface HeadlineSearchResultProps {
  headline: Headline
}

function getHeadlineImageUrl(headline: Headline, defaultBg: string): string {
  if (headline.cover_image_url_large) return headline.cover_image_url_large
  const firstMedia = headline.attached_media?.[0]
  if (firstMedia?.url) return firstMedia.url
  if (headline.external_photo_src) return headline.external_photo_src
  if (headline.link_preview?.best_image) return headline.link_preview.best_image
  return defaultBg
}

export const HeadlineSearchResult: React.FC<HeadlineSearchResultProps> = ({
  headline,
}) => {
  const defaultBg =
    "https://bandnada.s3.amazonaws.com/static/external_assets/web/bandnada_dysentery.png"

  const imageUrl = getHeadlineImageUrl(headline, defaultBg)

  return (
    <li className="col-span-1" style={{ height: "max-content" }}>
      <Link to={headline.nada_path}>
        <div
          style={{
            backgroundColor: "black",
            backgroundImage: imageUrl ? `url(${imageUrl})` : undefined,
            backgroundSize: "cover",
            backgroundPosition: "center",
            aspectRatio: "16/9",
          }}
          className="w-full rounded overflow-hidden"
        />
        <div className="font-bold leading-tight mt-2">
          {headline.title_cleaned || headline.title}
        </div>
        {headline.post_type_nice && (
          <div className="font-medium leading-tight text-gray-600 text-xs uppercase">
            {headline.post_type_nice}
          </div>
        )}
        {(headline.band_name || headline.published_at) && (
          <div className="text-gray-800 text-sm leading-tight">
            {headline.published_at && (
              <>
                {SmartDateFormat({
                  dateStr: headline.published_at,
                  includeTime: false,
                })}
              </>
            )}
            {headline.band_name && headline.published_at && " · "}
            {headline.band_name}
          </div>
        )}
      </Link>
    </li>
  )
}
